import settings from '../settings.json';
export const bpapiHost = settings.bpapiURL;
export const devapiHost = settings.boapiURL;
export const wsHost = settings.wsUrls.wsURL.useMsgpack ? settings.wsUrls.wsURL.urlMsgpack : settings.wsUrls.wsURL.url;
export const useMsgPack = settings.wsUrls.wsURL.useMsgpack;
export const wsTicketHost = settings.wsUrls.wsTicketURL.useMsgpack
	? settings.wsUrls.wsTicketURL.urlMsgpack
	: settings.wsUrls.wsTicketURL.url;
export const useMsgPackTicket = settings.wsUrls.wsTicketURL.useMsgpack;
